document.addEventListener('turbolinks:load', function () {
  if ($('.permits.new, .permits.create, .permits.edit, .permits.update').length === 0) {
    return false
  }

  // Only process permit forms, not other forms that might use processMultiStepForm
  if ($('#permit-form').length === 0) {
    return false
  }

  processPermitForm();

  function processForm(event, $clickedButton) {
    event.preventDefault();
    event.stopPropagation();
    
    // Disable the clicked button to prevent double-clicks
    $clickedButton.prop('disabled', true);
    
    showLoader();
    let currentSection = $(`#${$clickedButton.data('current')}`);

    if (currentSection.length !== 0) {
      // Validate required fields in current section
      let validationResult = validateRequiredFields(currentSection);
      if (!validationResult.isValid) {
        // Focus on the first error field
        if (validationResult.firstErrorField) {
          validationResult.firstErrorField.focus();
        }

        hideLoader();
        // Re-enable the button if validation fails
        $clickedButton.prop('disabled', false);
        return;
      }
    }
    submitForm($clickedButton.data("target-section"));
    hideLoader();
  }

  function hasErrorInTabs($btn) {
    let current = $btn.data('current');
    let hasError = false;

    $.each(current, function (index, tab) {
      let currentSection = $(`#${tab}`);
      if (currentSection.length !== 0) {
        let validationResult = validateRequiredFields(currentSection);
        if (!validationResult.isValid) {
          if (validationResult.firstErrorField) {
            validationResult.firstErrorField.focus();
          }
          hasError = true;
          return false; // break out
        }
      }
    });

    return hasError;
  }

  function processPermitForm() {
    $(document).off('click', '.next-step-btn').on('click', '.next-step-btn', function (e) {
      $('#permit_draft_save').val('true');
      processForm(e, $(this));
    });

    $(document).off('click', '#importQuestionsBtn, #importPermitFeesBtn').on('click', '#importQuestionsBtn, #importPermitFeesBtn', function (e) {
      $('#permit_draft_save').val('true');
      processForm(e, $(this));
    });



    processTabClickForm()

    $(document).off('click', '.save-btn').on('click', '.save-btn', function (e) {
      $('#permit_draft_save').val('false');
      $('#permit_draft').val('false');
      processForm(e, $(this));
    });

    // Handle previous step buttons (no need to save draft for going back)
    $(document).off('click', '.previous-step-btn').on('click', '.previous-step-btn', function (e) {
      e.preventDefault();
      e.stopPropagation();
      let targetSection = $(this).data("target-section");
      updateSectionAndRedirect(targetSection);
    });

    // Add real-time validation for required fields
    $(document).on('blur', '.requiredField', function() {
      validateSingleField($(this));
    });

    // Add real-time validation for select fields
    $(document).on('change', '.requiredField', function() {
      validateSingleField($(this));
    });
  }

  function processTabClickForm() {
    $(document).off('click', '.form-submit-tab').on('click', '.form-submit-tab', function (e) {
      showLoader();
      $('#permit_draft_save').val('true');

      let $btn = $(this);
      $btn.prop('disabled', true);

      if (hasErrorInTabs($btn)) {
        // Show error message
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Please fill all the required information before switching tabs.'
        });

        hideLoader();
        $btn.prop('disabled', false);

        // 🚨 prevent Bootstrap from handling the click
        e.stopImmediatePropagation();
        e.preventDefault(); // stops Bootstrap
        return false;       // stops propagation
      }

      // Passed validation → allow Bootstrap to continue with tab switch
      submitForm($btn.data("target-section"));
      hideLoader();
    });
  }

  function updateSectionAndRedirect(newSection) {
    // Get the current URL
    let url = new URL(window.location.href);

    // Use URLSearchParams to manage query parameters
    let params = url.searchParams;

    // Set or replace the "section" parameter
    params.set('section', newSection);

    // Update the URL with modified parameters
    url.search = params.toString();

    // Redirect to the new URL
    window.location.href = url.toString();
  }


  function validateRequiredFields(section) {
    let isValid = true;
    let firstErrorField = null;
    
    // Clear previous error states
    section.find('.requiredField').removeClass('is-invalid').removeClass('error-field');
    section.find('.error-message').remove();
    
    section.find('.requiredField').each(function() {
      let field = $(this);

      // Skip fields hidden inside their own section (fee type containers toggled by JS,
      // rows Cocoon hides on remove). Not :visible, since inactive tab panes are hidden too
      let hiddenInSection = field.parentsUntil(section).filter(function() {
        return this.style.display === 'none';
      }).length > 0;
      if (hiddenInSection) {
        return;
      }

      let fieldValue = field.val();
      let fieldType = field.attr('type');
      
      let isFieldValid = true;
      
      if (fieldType === 'file') {
        if (fieldValue.length === 0 && field.attr('data-files-present') !== "true") {
          isFieldValid = false;
        }
      } else if (fieldType === 'checkbox' || fieldType === 'radio') {
        if (!field.is(':checked')) {
          isFieldValid = false;
        }
      } else {
        if (fieldValue.length === 0 || fieldValue.trim() === '') {
          isFieldValid = false;
        }
      }
      
      if (!isFieldValid) {
        isValid = false;
        if (!firstErrorField) {
          firstErrorField = field;
        }
        
        // Add error styling and message
        field.addClass('is-invalid').addClass('error-field');
        
        // Add error message below the field
        let errorMessage = field.attr('data-error-message') || '';
        let errorElement = $('<div class="error-message text-danger small mt-1">' + errorMessage + '</div>');
        field.after(errorElement);
      }
    });
    
    return {
      isValid: isValid,
      firstErrorField: firstErrorField
    };
  }

  function validateSingleField(field) {
    let fieldValue = field.val();
    let fieldType = field.attr('type');
    
    // Remove previous error state
    field.removeClass('is-invalid').removeClass('error-field');
    field.siblings('.error-message').remove();
    
    let isValid = true;
    
    if (fieldType === 'file') {
      if (fieldValue.length === 0 && field.attr('data-files-present') !== "true") {
        isValid = false;
      }
    } else if (fieldType === 'checkbox' || fieldType === 'radio') {
      if (!field.is(':checked')) {
        isValid = false;
      }
    } else {
      if (fieldValue.length === 0 || fieldValue.trim() === '') {
        isValid = false;
      }
    }
    
    if (!isValid) {
      // Add error styling and message
      field.addClass('is-invalid').addClass('error-field');
      
      // Add error message below the field
      let errorMessage = field.attr('data-error-message') || '';
      let errorElement = $('<div class="error-message text-danger small mt-1">' + errorMessage + '</div>');
      field.after(errorElement);
    }
  }

  function submitForm(targetId) {
    $('#permit_section').val(targetId);
    
    // Submit the form via AJAX with proper file handling
    let form = $('#permit-form')[0];
    let formData = new FormData(form);
    
    // Set the section value in the form data
    formData.set('permit[section]', targetId);
    
    $.ajax({
      url: $(form).attr('action'),
      method: $(form).attr('method'),
      data: formData,
      processData: false,
      contentType: false,
      dataType: 'script',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function() {
        console.info('Saved draft successfully');
      },
      error: function(error) {
        // Reset the draft save flag
        $('#permit_draft_save').val('false');
        
        // Re-enable all buttons on error
        $('.next-step-btn, .save-btn').prop('disabled', false);
        
        // Show error message
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to save draft. Please try again.'
        });
      }
    });
  }
});

function showLoader() {
  $('.loading-spinner').show();
  $('body').css({
    pointerEvents: "none"
  })
}

function hideLoader() {
  $('.loading-spinner').hide();
  $('body').css({
    pointerEvents: "auto"
  });
}